import {
  getAttributes,
  createAttribute,
  updateAttribute,
  updateOrderAttributes as updateAllAttributes,
  deleteAttribute,
  AttributeListItem,
  getVideoAttributes,
  putVideoAttributes,
} from 'lib/api';
import {
  ATTRIBUTES_ACTIONS,
  CreateParams,
  QueryParams,
  UpdateAttributeParams,
} from '.';

const {
  GET_ATTRIBUTES_START,
  GET_ATTRIBUTES_ERROR,
  GET_ATTRIBUTES_SUCCESS,
  ADD_ATTRIBUTES_START,
  ADD_ATTRIBUTES_ERROR,
  ADD_ATTRIBUTES_SUCCESS,
  EDIT_ATTRIBUTES_START,
  EDIT_ATTRIBUTES_ERROR,
  EDIT_ATTRIBUTES_SUCCESS,
  DELETE_ATTRIBUTES_START,
  DELETE_ATTRIBUTES_ERROR,
  DELETE_ATTRIBUTES_SUCCESS,
  UPDATE_ORDER_ATTRIBUTES_START,
  UPDATE_ORDER_ATTRIBUTES_ERROR,
  UPDATE_ORDER_ATTRIBUTES_SUCCESS,
  GET_VIDEO_ATTRIBUTES_START,
  GET_VIDEO_ATTRIBUTES_SUCCESS,
  UPDATE_VIDEO_ATTRIBUTES_START,
  UPDATE_VIDEO_ATTRIBUTES_SUCCESS,
} = ATTRIBUTES_ACTIONS;

export const loadAttributes = async ({
  dispatch,
  filterByDepartment = false,
}: QueryParams): Promise<void> => {
  dispatch({ type: GET_ATTRIBUTES_START });

  const response = await getAttributes({ filterByDepartment }).catch(
    err => err
  );
  if (response instanceof Error) {
    dispatch({
      type: GET_ATTRIBUTES_ERROR,
      error: response.message,
    });
    return;
  }
  const payload = response;
  dispatch({ type: GET_ATTRIBUTES_SUCCESS, payload });
};

export const addAttribute = async ({
  data,
  dispatch,
}: CreateParams): Promise<void> => {
  dispatch({ type: ADD_ATTRIBUTES_START });

  const attribute = await createAttribute({ data }).catch(err => err);
  if (attribute instanceof Error) {
    dispatch({
      type: ADD_ATTRIBUTES_ERROR,
      error: attribute.message,
    });
    return;
  }
  const payload = {
    attribute,
  };
  dispatch({ type: ADD_ATTRIBUTES_SUCCESS, payload });
};

export const editAttribute = async (
  params: UpdateAttributeParams
): Promise<void> => {
  const { data, dispatch } = params;
  dispatch({ type: EDIT_ATTRIBUTES_START });

  const attribute = await updateAttribute(data as AttributeListItem).catch(
    err => err
  );
  if (attribute instanceof Error) {
    dispatch({
      type: EDIT_ATTRIBUTES_ERROR,
      error: attribute.message,
    });
    return;
  }
  const payload = {
    attribute,
  };
  dispatch({ type: EDIT_ATTRIBUTES_SUCCESS, payload });
};

export const removeAttribute = async ({
  data,
  dispatch,
}: CreateParams): Promise<void> => {
  dispatch({ type: DELETE_ATTRIBUTES_START });

  const attribute = await deleteAttribute(data.attributeId).catch(err => err);
  if (attribute instanceof Error) {
    dispatch({
      type: DELETE_ATTRIBUTES_ERROR,
      error: attribute.message,
    });
    return;
  }
  const payload = {
    attribute: data,
  };
  dispatch({ type: DELETE_ATTRIBUTES_SUCCESS, payload });
};

export const updateOrderAttributes = async ({
  data,
  dispatch,
}: CreateParams): Promise<void> => {
  dispatch({ type: UPDATE_ORDER_ATTRIBUTES_START });

  const attributes = await updateAllAttributes(data).catch(err => err);
  if (attributes instanceof Error) {
    dispatch({
      type: UPDATE_ORDER_ATTRIBUTES_ERROR,
      error: attributes.message,
    });
    return;
  }
  const payload = {
    attributes,
  };
  dispatch({ type: UPDATE_ORDER_ATTRIBUTES_SUCCESS, payload });
};

export const loadVideoAttributes = async ({
  dispatch,
  videoId,
}: any): Promise<void> => {
  dispatch({ type: GET_VIDEO_ATTRIBUTES_START });

  const response = await getVideoAttributes({ videoId }).catch(err => err);
  if (response instanceof Error) {
    dispatch({
      type: GET_ATTRIBUTES_ERROR,
      error: response.message,
    });
    return;
  }
  const payload = response;
  dispatch({ type: GET_VIDEO_ATTRIBUTES_SUCCESS, payload });
};

export const updateVideoAttributes = async ({
  videoId,
  data,
  dispatch,
}: any): Promise<void> => {
  dispatch({ type: UPDATE_VIDEO_ATTRIBUTES_START });

  const response = await putVideoAttributes(videoId, data).catch(err => err);
  if (response instanceof Error) {
    dispatch({
      type: UPDATE_ORDER_ATTRIBUTES_ERROR,
      error: response.message,
    });
    return;
  }
  const payload = response;
  dispatch({ type: UPDATE_VIDEO_ATTRIBUTES_SUCCESS, payload });
};
